import { Defaults } from 'es-decorators'
import { Collection } from 'es6/components/collection'
import { entryScriptName } from 'init/entry-script-name'

/**
 * Коллекция для валют
 */
@Defaults({
  url: `${entryScriptName}/api/v3/currency/`,
})
export class Currencies extends Collection {
  /**
   * Устанавливает текущую валюту.
   *
   * @param {string} name имя валюты
   * @param {boolean} [silent]
   */
  setCurrent (name, silent = false) {
    let tmpCurrent = this.findWhere({ current: true })
    if (tmpCurrent) {
      tmpCurrent.set({ current: false }, { silent: true })
    }

    this.findWhere({ name: name }).set({ current: true }, { silent: silent })
  }

  /**
   * Возвращает объект текущей валюты.
   *
   * @returns {Model} модель с текущей валютой
   */
  getCurrent () {
    return this.findWhere({ current: true })
  }
}
